import { render, staticRenderFns } from "./landCardDetail.vue?vue&type=template&id=f2ded4cc&scoped=true"
import script from "./landCardDetail.vue?vue&type=script&lang=js"
export * from "./landCardDetail.vue?vue&type=script&lang=js"
import style0 from "./landCardDetail.vue?vue&type=style&index=0&id=f2ded4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ded4cc",
  null
  
)

export default component.exports